import React from "react";

import svg from "../../assets/images/icons/dragdrop_blue.svg";

export const DragDropBlueIcon = ({ alt }: { alt?: string }) => (
    <img
        src={svg}
        alt={alt || "Drag and Drop"}
    />
);
